define.alias("ember-composable-helpers/helpers/reject-by", "settings/helpers/reject-by");